import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import { Layout, Menu, Button } from 'antd'
import {
  HomeOutlined,
  FileTextOutlined,
  ToolOutlined,
  BarChartOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons'
import store from '@store/index'
import { Dashboard, MaterialRequests, Operations, CreateDailyReport, Analytics } from '@pages/index'
import {
  InventoryHub,
  ToolsList,
  UnitsList,
  PanelsList,
  PressureEquipmentList,
  ConsumablesList,
} from '@pages/Inventory'
import './App.css'

const { Sider, Content, Header } = Layout

interface MenuItem {
  key: string
  icon: React.ReactNode
  label: React.ReactNode
  path: string
}

const menuItems: MenuItem[] = [
  { key: '1', icon: <HomeOutlined />, label: 'Dashboard', path: '/' },
  {
    key: '2',
    icon: <FileTextOutlined />,
    label: 'Material Requests',
    path: '/material-requests',
  },
  { key: '3', icon: <ToolOutlined />, label: 'Operations', path: '/operations' },
  { key: '4', icon: <ToolOutlined />, label: 'Inventory', path: '/inventory' },
  { key: '5', icon: <BarChartOutlined />, label: 'Analytics', path: '/analytics' },
]

function AppLayout() {
  const [collapsed, setCollapsed] = React.useState(false)
  const [selectedKey, setSelectedKey] = React.useState('1')

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div style={{ padding: '16px', textAlign: 'center', color: 'white', marginBottom: '16px' }}>
          <h2 style={{ color: 'white', margin: '0' }}>
            {collapsed ? 'EAT' : 'Expro Asset Tracker'}
          </h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems.map((item) => ({
            key: item.key,
            icon: item.icon,
            label: <Link to={item.path}>{item.label}</Link>,
          }))}
          onClick={(e) => setSelectedKey(e.key)}
        />
      </Sider>

      <Layout style={{ marginLeft: collapsed ? 80 : 200, transition: 'margin-left 0.2s' }}>
        <Header
          style={{
            background: '#fff',
            padding: '0 24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: '16px' }}
          />
          <div>
            <p style={{ margin: 0, fontSize: '12px', color: '#999' }}>
              Phase 1: Tool Inventory & Certification Management | 71 Integration Tests Passing ✅
            </p>
          </div>
        </Header>

        <Content style={{ margin: '0' }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/material-requests" element={<MaterialRequests />} />
            <Route path="/operations" element={<Operations />} />
            <Route path="/daily-reports/create" element={<CreateDailyReport />} />
            <Route path="/inventory" element={<InventoryHub />} />
            <Route path="/inventory/tools" element={<ToolsList />} />
            <Route path="/inventory/units" element={<UnitsList />} />
            <Route path="/inventory/panels" element={<PanelsList />} />
            <Route path="/inventory/pressure-equipment" element={<PressureEquipmentList />} />
            <Route path="/inventory/consumables" element={<ConsumablesList />} />
            <Route path="/analytics" element={<Analytics />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  )
}

export default function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppLayout />
      </Router>
    </Provider>
  )
}
